import View from "./view.js";
import icons from "url:../../img/icons.svg";

class PaginationView extends View {
  _parentElement = document.querySelector(".pagination");

  addHandlerClick(handler) {
    this._parentElement.addEventListener("click", function (e) {
      const btn = e.target.closest(".btn--inline");

      if (!btn) return;

      const goToPage = +btn.dataset.goto;

      handler(goToPage);
    });
  }

  _generateMarkup() {
    const curPage = this._data.page;

    const numPages = Math.ceil(
      this._data.result.length / this._data.resultsPerPage
    );

    //   Page 1, and there are other pages
    if (curPage === 1 && numPages > 1) {
      return this._generateMarkupButton("next", curPage);
    }
    // last page
    if (curPage === numPages && numPages > 1) {
      return this._generateMarkupButton("prev", curPage);
    }
    // Other page
    if (curPage < numPages) {
      let string = this._generateMarkupButton("prev", curPage);
      string += this._generateMarkupButton("next", curPage);

      return string;
    }
    //   Page 1, and there are no other pages
    return ``;
  }

  _generateMarkupButton(flip, curPage) {
    if (flip === "prev") {
      return `
        <button data-goto="${
          curPage - 1
        }" class="btn--inline pagination__btn--${flip}">
            <svg class="search__icon">
                <use href="${icons}#icon-arrow-left"></use>
            </svg>
            <span>Page ${curPage - 1} </span>
        </button>
      `;
    } else {
      return `
          <button data-goto="${
            curPage + 1
          }" class="btn--inline pagination__btn--${flip}">
          <span>Page ${curPage + 1}</span>
          <svg class="search__icon">
              <use href="${icons}#icon-arrow-right"></use>
          </svg>
          </button>
        `;
    }
  }
}

export default new PaginationView();
